var _Path, _Path2, _Path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgItemNone = function SvgItemNone(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 76,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 76 76"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    stroke: "#A88E86",
    strokeWidth: 4,
    d: "M38 62c13.255 0 24-10.745 24-24S51.255 14 38 14 14 24.745 14 38s10.745 24 24 24Z"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "#000",
    d: "m21 21 34 34Z"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    stroke: "#A88E86",
    strokeWidth: 4,
    d: "m21 21 34 34"
  })));
};
export default SvgItemNone;